import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Loader } from '../components/Loader';
import { Error } from '../components/Error';

import GenerateMetaTags from '../components/GenerateMetaTags';
import Breadcrumbs from '../components/Breadcrumbs';
import Article, { Title } from '../components/Article';
import PostGrid from '../components/PostsGrid';
import { TransitionWrapper } from '../components/TransitionWrapper';

const GET_ARCHIVE_PAGE = gql`
  query getArchivePage($slug: String!, $page: Int!, $per_page: Int!) {
    posts: getWPPostsByCategorySlug(
      categorySlug: $slug
      page: $page
      per_page: $per_page
    ) {
      total
      totalPages
      items {
        id
        title {
          rendered
        }
        embedded {
          featuredmedia {
            media_details {
              file
            }
          }
        }
      }
    }
  }
`;

class ArchivePage extends Component {
  state = {
    currentPage: 1
  };

  render() {
    return (
      <TransitionWrapper>
        <Helmet>
          {GenerateMetaTags({
            title: 'Aktuelt',
            description: 'Aktuelle saker fra Bil1Din.'
          })}
        </Helmet>

        <Breadcrumbs breadcrumbs={null} />

        <Article>
          <Title>Aktuelt</Title>

          <Query
            query={GET_ARCHIVE_PAGE}
            variables={{
              slug: 'aktuelt',
              page: 1,
              per_page: 9
            }}
            notifyOnNetworkStatusChange={true}
          >
            {({ loading, error, data, fetchMore }) => {
              if (loading && !data.posts) {
                return <Loader />;
              }

              if (error) {
                return <Error error={error} />;
              }

              if (!data.posts.items || data.posts.items.length === 0) {
                //@todo: Redirect to 404
                return <div>Ikke funnet</div>;
              }

              return (
                <PostGrid
                  posts={data.posts.items}
                  loading={loading}
                  currentPage={this.state.currentPage}
                  totalPages={data.posts.totalPages}
                  onLoadMore={() => {
                    fetchMore({
                      variables: {
                        page: this.state.currentPage + 1
                      },
                      updateQuery: (prev, { fetchMoreResult }) => {
                        if (!fetchMoreResult) return prev;

                        let mergedResult = Object.assign(
                          {},
                          prev,
                          fetchMoreResult
                        );

                        mergedResult.posts.items = [
                          ...prev.posts.items,
                          ...fetchMoreResult.posts.items
                        ];

                        return mergedResult;
                      }
                    });
                    this.setState({
                      currentPage: this.state.currentPage + 1
                    });
                  }}
                />
              );
            }}
          </Query>
        </Article>
      </TransitionWrapper>
    );
  }
}

export default ArchivePage;
